(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-footer-accordion"] && !Shopify.designMode) return;
  try {
    (() => {
    const mobileQuery = window.matchMedia(
      '(max-width: 749px)'
    );

    const accordionTitles = [
      'company',
      'products',
      'contact us'
    ];

    const setButtonState = (
      button,
      expanded
    ) => {
      button.setAttribute(
        'aria-expanded',
        expanded ? 'true' : 'false'
      );

      const block = button.closest(
        '.mobile-footer-accordion'
      );

      const panelId = button.getAttribute(
        'aria-controls'
      );

      const panel = panelId
        ? document.getElementById(panelId)
        : null;

      if (block) {
        block.classList.toggle(
          'is-open',
          expanded
        );
      }

      if (panel) {
        panel.hidden = mobileQuery.matches
          ? !expanded
          : false;
      }
    };

    const syncAccordionState = (
      root = document
    ) => {
      root
        .querySelectorAll(
          '.mobile-footer-accordion__button'
        )
        .forEach((button) => {
          if (mobileQuery.matches) {
            const expanded =
              button.dataset.mobileExpanded ===
              'true';

            setButtonState(
              button,
              expanded
            );
          } else {
            setButtonState(
              button,
              true
            );
          }
        });
    };

    const initializeFooterAccordion = (
      root = document
    ) => {
      const footer =
        root.querySelector('footer') ||
        document.querySelector('footer');

      if (!footer) return;

      const headings = footer.querySelectorAll(
        '.footer-block__heading, .footer__heading, h2, h3, h4'
      );

      headings.forEach(
        (heading, index) => {
          const normalizedTitle =
            heading.textContent
              .trim()
              .toLowerCase();

          if (
            !accordionTitles.includes(
              normalizedTitle
            )
          ) {
            return;
          }

          const block =
            heading.closest(
              '.footer-block, .footer__block, .footer__column, .footer-block--menu, [data-shopify-editor-block]'
            ) ||
            heading.parentElement;

          if (
            !block ||
            block.dataset
              .mobileAccordionInitialized ===
              'true'
          ) {
            return;
          }

          const contentNodes =
            Array.from(
              block.children
            ).filter(
              (node) =>
                node !== heading
            );

          if (
            contentNodes.length === 0
          ) {
            return;
          }

          const panel =
            document.createElement(
              'div'
            );

          const button =
            document.createElement(
              'button'
            );

          const label =
            document.createElement(
              'span'
            );

          const icon =
            document.createElement(
              'span'
            );

          const panelId =
            `MobileFooterPanel-${index}-` +
            Math.random()
              .toString(36)
              .slice(2, 8);

          block.dataset
            .mobileAccordionInitialized =
            'true';

          block.classList.add(
            'mobile-footer-accordion'
          );

          heading.classList.add(
            'mobile-footer-accordion__heading'
          );

          button.type = 'button';

          button.className =
            'mobile-footer-accordion__button';

          button.setAttribute(
            'aria-controls',
            panelId
          );

          button.dataset
            .mobileExpanded =
            'false';

          label.textContent =
            heading.textContent.trim();

          icon.className =
            'mobile-footer-accordion__icon';

          icon.setAttribute(
            'aria-hidden',
            'true'
          );

          panel.id = panelId;

          panel.className =
            'mobile-footer-accordion__panel';

          button.append(
            label,
            icon
          );

          heading.replaceChildren(
            button
          );

          contentNodes.forEach(
            (node) => {
              panel.appendChild(
                node
              );
            }
          );

          heading.insertAdjacentElement(
            'afterend',
            panel
          );

          button.addEventListener(
            'click',
            () => {
              if (
                !mobileQuery.matches
              ) {
                return;
              }

              const expanded =
                button.getAttribute(
                  'aria-expanded'
                ) === 'true';

              button.dataset
                .mobileExpanded =
                expanded
                  ? 'false'
                  : 'true';

              setButtonState(
                button,
                !expanded
              );
            }
          );
        }
      );

      syncAccordionState(root);
    };

    const start = () => {
      initializeFooterAccordion(
        document
      );
    };

    if (
      document.readyState ===
      'loading'
    ) {
      document.addEventListener(
        'DOMContentLoaded',
        start,
        {
          once: true
        }
      );
    } else {
      start();
    }

    mobileQuery.addEventListener(
      'change',
      () => {
        syncAccordionState(
          document
        );
      }
    );

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initializeFooterAccordion(
          event.target
        );
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
